import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'next/router'
import Link from 'next/link'

const BackUrl = ({ router }) => {
  return (
    <a href='javascript:void(0)' onClick={() => router.back()}>
      <i className='ico-nazad ico' />
      <p>Nazad</p>
    </a>
  )
}

BackUrl.propTypes = {
  router: PropTypes.shape({
    back: PropTypes.func
  }).isRequired
}

export default withRouter(BackUrl)
